import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpEvent, HttpRequest } from '@angular/common/http';

@Injectable()
export class WsFileService {
    endpoint = `/api/files`;

    constructor(
        private http: HttpClient
    ) { }

    upload(files: FileList | File[], directory?: string): Observable<any> {
        const formData = new FormData();
        if (directory) {
            formData.append('directory', directory);
        }

        for (let i = 0; i < files.length; i++) {
            formData.append(`file${i + 1}`, files[i]);
        }

        return this.http.post(`${this.endpoint}/upload`, formData, {
            reportProgress: true,
            observe: 'events'
        });
    }

    delete(url: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                context: '.dropzone'
            }),
            body: { url }
        };
        return this.http.delete(`${this.endpoint}`, httpOptions);
    }

    deleteMultiple(path, files) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                context: '.dropzone'
            }),
            body: { path, files }
        };
        return this.http.delete(`${this.endpoint}/delete-files`, httpOptions);
    }

    getFiles(folder?: string): Observable<[]> {
        return this.http.get<[]>(`${this.endpoint}?folder=${folder || ''}`, { headers: { context: '.dropzone' } });
    }

    createDirectory(path: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', context: '.dropzone' });
        return this.http.post(`${this.endpoint}/create-directory`, `=${path}`, { headers });
    }

    rename(path: string, file, newFile) {
        return this.http.post(`${this.endpoint}/rename`, { path, file, newFile });
    }

    getDirectories(path: string): Observable<string[]> {
        return this.http.get<string[]>(`${this.endpoint}/directories?path=${path}`, { headers: { context: '.modal-body' } });
    }

    move(origin: string, target: string, files: any): Observable<any> {
        return this.http.post(`${this.endpoint}/move`, { origin, target, files }, { headers: { context: '.dropzone' } });
    }

    download(url): Observable<HttpEvent<Blob>> {
        // const headers = new HttpHeaders().set('content-type', 'multipart/form-data');
        // return this.http.get(`${this.endpoint}/download?url=${url}`, null, { headers, responseType: 'blob' });

        return this.http.request(new HttpRequest(
            'GET',
            `${this.endpoint}/download?url=${url}`,
            null,
            {
                reportProgress: true,
                responseType: 'blob'
            }));
    }

    zip(url, ctx?): Observable<any> {
        return this.http.post(`${this.endpoint}/zip?url=${url}`, null, { headers: { context: ctx || '' } });
    }

    unzip(url, ctx?): Observable<any> {
        return this.http.post(`${this.endpoint}/unzip?url=${url}`, null, { headers: { context: ctx || '' } });
    }
}
